import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { KMCDepartmentLeftManu } from "../components/KMCDepartmentLeftManu";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  return (
    <>
      {/* Slider */}
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <KMCDepartmentLeftManu />
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title">
                    <h3 className="fontSizeClass">{t("Vision")} </h3>
                  </div>
                  <div className="about-head1">
                    <h4 className="fontSizeClass">
                      "
                      {t(
                        "KMC will be efficient, effective, equitable, citizen responsive, financially sustainable and transparent, delivering quality service to its citizens"
                      )}
                      ."
                    </h4>
                  </div>
                  <div className="col-lg-12 about-img2">
                    <img
                      src="assets/img/vision.jpg"
                      className="img-fluid"
                      alt="alt"
                    />
                    <p className="fontSizeClass">
                      {t(
                        "We have a vision. We believe that Kolkata has the potential to be one of the best cities of the world. We see Kolkata as a clean and attractive city of international repute in which all people have access to quality services"
                      )}
                      .
                    </p>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <h5 className="fontSizeClass">
                      {t("In our vision, KMC will be")} :-
                    </h5>
                    <p className="fontSizeClass">
                      <strong> {t("Efficient and effective")} - </strong>
                      {t(
                        "providing service to its customers in a professional, economical, timely, useful and helpful manner"
                      )}
                      .
                    </p>
                    <p className="fontSizeClass">
                      <strong> {t("Equitable")} -</strong>
                      {t(
                        "assuring service to all its citizens including the vulnerable and deprived groups in a fair, just and reasonable manner"
                      )}
                      .
                    </p>
                    <p className="fontSizeClass">
                      <strong> {t("Citizen responsive")} -</strong>
                      {t(
                        "developing a sense of involvement and participation in all its stakeholders by pro-actively addressing their concerns and providing complete customer satisfaction"
                      )}
                      .
                    </p>
                    <p className="fontSizeClass">
                      <strong> {t("Financially sustainable")} - </strong>
                      {t(
                        "reducing KMC’s dependence on state funds by optimising and efficiently managing its revenues, and"
                      )}
                    </p>
                    <p className="fontSizeClass">
                      <strong> {t("Transparent")} - </strong>
                      {t(
                        "providing an accountable and transparent civic administration for the benefit of external users as well as internal employees"
                      )}
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
